"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GoogleMapPinInRegion_1 = require("@/pages/place/components/GoogleMapPinInRegion");
var BlockTopGallery = function (props) {
    var _a = React.useState(false), hasDragged = _a[0], setHasDragged = _a[1];
    var _b = React.useState({}), loadedImgs = _b[0], setLoadedImgs = _b[1];
    var getImg = function (item, i) {
        var normalRender = function () { return (React.createElement("img", { src: item.src, alt: item.text })); };
        if (loadedImgs[item.src]) {
            return normalRender();
        }
        if (props.slideIndex === i) {
            var newLoadedImgs = __assign({}, loadedImgs);
            newLoadedImgs[item.src] = true;
            setLoadedImgs(newLoadedImgs);
            return normalRender();
        }
    };
    var renderMapSlide = function (props) {
        var onMouseDown = function () {
            setHasDragged(false);
        };
        var onMouseMove = function () {
            setHasDragged(true);
        };
        var onMouseUp = function () {
            if (hasDragged)
                return;
            props.onMapClick();
        };
        return props.mapReady && props.slideIndex === -1 ? (React.createElement("div", { key: -1, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseUp: onMouseUp, className: "c-propslider__slide" },
            React.createElement(GoogleMapPinInRegion_1.GoogleMapPinInRegion, { googleApikey: props.googleApikey, location: props.location, regionName: props.regionName }))) : (React.createElement("div", { key: -1, className: "c-propslider__slide" }));
    };
    var renderSlide = function (item, i) {
        var onSlideClicked = function () { return props.onItemClick(item); };
        return (React.createElement("div", { onClick: onSlideClicked, key: i, className: "c-propslider__slide" },
            getImg(item, i),
            item.playable ? (React.createElement("div", { className: "c-propslider__slide-overlay" },
                React.createElement("span", { className: "fas fa-play" }))) : null,
            React.createElement("div", { className: "c-propslider__caption" },
                React.createElement("div", { className: "c-propslider__caption-text" }, item.text))));
    };
    var renderDot = function (item, i, isActive) {
        var onDotClick = function () {
            props.setBlockTopGalleryScroll(i);
            props.onSlideIndexChanged(i);
        };
        var dotClass = "c-place__dot " + (isActive ? 'c-place__dot--active' : '');
        return (React.createElement("div", { onClick: onDotClick, key: i, className: dotClass },
            React.createElement("span", { className: "fal fa-circle" })));
    };
    var blockTopGalleryItems = props.items
        .map(function (it) {
        var isSrcVimeo = Number(it.src).toString() === it.src;
        return {
            src: isSrcVimeo ? it.thumb : it.src,
            text: it.text,
            playable: isSrcVimeo,
        };
    });
    var renderDots = function (props) {
        return blockTopGalleryItems
            .map(function (item, i) { return renderDot(item, i, props.slideIndex === i); });
    };
    var onPrevClick = function () {
        var initSlideIndex = props.location.lat ? -1 : 0;
        var newIndex = props.slideIndex === initSlideIndex ? props.items.length - 1 : props.slideIndex - 1;
        props.setBlockTopGalleryScroll(newIndex);
        props.onSlideIndexChanged(newIndex);
    };
    var onNextClick = function () {
        var initSlideIndex = props.location.lat ? -1 : 0;
        var newIndex = props.slideIndex === props.items.length - 1 ? initSlideIndex : props.slideIndex + 1;
        props.setBlockTopGalleryScroll(newIndex);
        props.onSlideIndexChanged(newIndex);
    };
    var isMapDotActive = props.slideIndex === -1;
    var mapDotClass = "c-place__dot " + (isMapDotActive ? 'c-place__dot--active' : null);
    var onMapDotClick = function () {
        props.setBlockTopGalleryScroll(-1);
        props.onSlideIndexChanged(-1);
    };
    var renderControls = function () {
        return (React.createElement("div", { className: "c-place__controls" },
            React.createElement("div", { onClick: onPrevClick, className: "c-place__control" },
                React.createElement("span", { className: "fal fa-chevron-left" })),
            React.createElement("div", { onClick: onNextClick, className: "c-place__control" },
                React.createElement("span", { className: "fal fa-chevron-right" }))));
    };
    if (!props.location.lat && !blockTopGalleryItems.length)
        return (React.createElement("div", { className: "c-building__noimg" },
            React.createElement("img", { src: "/res/img/nopic.jpg" })));
    return (React.createElement("div", { className: "c-place__img" },
        React.createElement("div", { id: "blockTopGallery", className: "c-propslider__slides" },
            blockTopGalleryItems.map(renderSlide),
            props.location.lat ? renderMapSlide(props) : null),
        blockTopGalleryItems.length ? renderControls() : null,
        React.createElement("div", { className: "c-place__dots" },
            renderDots(props),
            props.location.lat ? React.createElement("div", { onClick: onMapDotClick, key: -1, className: mapDotClass },
                React.createElement("span", { className: "fal fa-map" })) : null)));
};
exports.default = BlockTopGallery;
